var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.1346 24.6675C13.2192 25.8768 15.6686 26.2814 18.027 25.8057C20.3854 25.3301 22.492 24.0067 23.9547 22.0819C25.4175 20.157 26.1367 17.7619 25.9785 15.3424C25.8203 12.9228 24.7956 10.6436 23.0949 8.92894C21.3942 7.21432 19.1336 6.18113 16.7337 6.02166C14.3338 5.86219 11.9582 6.58732 10.0491 8.06208C8.13992 9.53683 6.8273 11.6607 6.35553 14.0385C5.88376 16.4162 6.28499 18.8857 7.48452 20.9875L7.48783 20.993C7.56828 21.1341 7.60905 21.2052 7.62779 21.273C7.64542 21.3364 7.64983 21.393 7.64542 21.4597C7.63202 21.5589 7.60609 21.656 7.56828 21.7486L6.22614 24.4735L6.22504 24.4768C6.0465 25.0179 5.95723 25.2879 6.02005 25.4679C6.07516 25.6257 6.19969 25.749 6.35508 25.8057C6.53361 25.869 6.80031 25.7802 7.33481 25.6002L7.34143 25.5979L10.3785 24.5819C10.5229 24.533 10.5967 24.5086 10.6673 24.5041C10.7293 24.4993 10.7916 24.5057 10.8513 24.523C10.9491 24.5597 11.0426 24.607 11.1301 24.6641L11.1346 24.6675Z",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChat);
export default __webpack_public_path__ + "static/media/chat.5430f6bde2ed76d818405a7c6062fd9a.svg";
export { ForwardRef as ReactComponent };